import { v } from "convex/values";

/**
 * A validator admitting exactly the strings in `values`.
 *
 * A closed set of string members is normally written twice in this tier — once
 * as an `as const` list the app and the Postgres schema read, and once as a
 * `v.union(v.literal(...))` the Convex field takes. The two then drift on the
 * next member. Declaring the list and deriving the union from it means adding
 * a member in one place admits it everywhere.
 *
 * The derived type is the same union `v.union(v.literal("a"), v.literal("b"))`
 * produces, so schema fields, `Infer<>`, and the generated data model are
 * unchanged by the switch.
 */
export function literalsValidator<T extends string>(values: readonly [T, ...T[]] | readonly T[]) {
    return v.union(...values.map((value) => v.literal(value)));
}
